import React, { Suspense, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./ArticleCommentList.modules.less";
import ScrollLoad from "@Components/common/ScrollLoad";
import CommentList from "./CommentList";
import WriteComment from "./WriteComment";
import { loginAtom } from "@Lib/jotai/login";
import { useAtom } from "jotai";

import { article } from "@Api";
import { Spin } from "antd";

const { fatchArticleGetComment, mobileArticleAddComment } = article;

const NewComment = React.lazy(() => import("@Components/movie/Details/Comment/NewComment/index"));

interface IState {
  commentNum: any;
  commentData: any[];
  hotComment: any[];
  paging: string;
}

const Content = () => {
  const [loginInfo, updateLoginInfo] = useAtom(loginAtom);
  const { id, type } = window.article;
  const [remarkData, setRemarkData] = useState<IState>({
    commentNum: "---",
    commentData: [],
    hotComment: [],
    paging: "",
  });
  const [showLoading, setShowLoading] = useState(false);

  const getList = async () => {
    setShowLoading(true);
    try {
      const res = await fatchArticleGetComment({ id, type });
      res && articleComment(res);
    } catch (error) {
      setShowLoading(false);
      console.log(error);
    }
  };

  const articleComment = (data: any) => {
    const hotArr: any = [],
      newArr: any = [];

    hotArr.push(data.hotComment);
    newArr.push(data.data);

    setRemarkData({
      commentData: data?.data?.length === 0 ? [] : newArr,
      commentNum: data?.comment_num,
      paging: data.paging,
      hotComment: data?.hotComment?.length === 0 ? [] : hotArr,
    });
    setShowLoading(false);
  };

  const refreshList = () => {
    setRemarkData({
      commentNum: "---",
      commentData: [],
      hotComment: [],
      paging: "",
    });
    getList();
  };

  useEffect(() => {
    getList();
    updateLoginInfo()
  }, [window.article]);

  return (
    <section className="p-40">
      <Suspense fallback={''}>
        {!!window.article.id && <NewComment
          id={window.article.id || 0}
          sendCommentApi={mobileArticleAddComment}
          type={type}
          pageType={'article'}
        />}
      </Suspense>
    </section>
  );
};

const $app = document.getElementById("articles-remark");
!!$app && ReactDOM.render(<Content />, $app);
